import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=c08b546e&scoped=true&"
import script from "./MainPanel.vue?vue&type=script&lang=js&"
export * from "./MainPanel.vue?vue&type=script&lang=js&"
import style0 from "./MainPanel.vue?vue&type=style&index=0&id=c08b546e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08b546e",
  null
  
)

export default component.exports